
	import itemBox from "@/components/item-box.vue";
	export default {
		name: "database",
		components: {
			itemBox,
		},
		data() {
			return {
				filters: {}
			};
		},

        async asyncData({ $axios }) {
            const products = await $axios.$get("/pomucky/search");
            return { products };
        },

	};
